<template>
  <div class="title" :style="{'background':bgcolor?bgcolor:'#f0f2f5'}">
    {{ HomeTitle }} &trade;
  </div>
</template>

<script>
export default {
  props: ['HomeTitle','bgcolor'],
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
@media only screen and (min-width: 768px) {
  .title {
    height: 400px;
    min-width: 1200px;
    font-size: 40px;
    font-family:'PingFang SC';
    font-weight: 400;
    color: #0f1e3d;
    line-height: 400px;
    text-align: center;
    
  }
}
@media only screen and (max-width: 767px) {
  .title {
    font-size: 0.94rem;
    font-weight: 500;
    color: #0f1e3d;
    padding: 5rem 0;
    background: #f0f2f5;
    font-family:'PingFang SC';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comcomponents/Title.vue